import fetch from 'isomorphic-fetch'
// http://stackoverflow.com/questions/32793404/es6-export-overwriting-function
import sha1 from 'sha1'

import {
  isFindomestic,
  totale_ordine_equal_totale_finanziamento,
} from '../../components/buy/utils'
import * as types from '../../constants/ActionTypes'
import {
  fetching,
  getDefaultFinancements,
  getOrdine,
  newDefaultFinancements,
  newDefaultFinancementsFindomestic,
} from '../Buy'
import { errorNotice } from '../ErrorNotice'
import { postSlack } from '../SlackWebhook'
import { setCompassCalcolatriceLogistica } from './Logistica'

const createBasicCreator = actionType => payload => ({
  type: actionType,
  payload,
})

const fetch_getTabelleDominioCompass =
  actionType => payload => (dispatch, getState) => {
    dispatch(
      fetching({
        fetching: true,
      })
    )

    dispatch({ type: actionType })

    const headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${payload.token}`,
      'X-Brum-Session-Id': getState().uuid,
      'sentry-trace': getState().uuid,
    })

    const fetch_options = {
      method: 'GET',
      headers,
    }

    const uri = `${window.brumbrum.url_api}/compass/t/v1/values/${payload.section}`

    return new Promise((resolve, reject) => {
      fetch(uri, fetch_options)
        .then(response => {
          /**
           * fatto cosi seguendo l'esempio
           * https://github.com/reactjs/redux/blob/master/examples/real-world/src/middleware/api.js#L26
           */
          response
            .text()
            .then(text => {
              let json = false
              try {
                json = JSON.parse(text)
              } catch (ex) {
                dispatch(
                  errorNotice({
                    type: 'generic',
                  })
                )
                dispatch(
                  fetching({
                    fetching: false,
                  })
                )
                reject(ex)
              }

              const response_details = {
                body_text: text,
                body_json: json,
                status: response.status,
                text: response.statusText,
                url: response.url,
                xray: sha1(
                  Math.random() + new Date().getTime() + uri
                ).substring(0, 7),
                type: 'generic',
              }

              if (response.status >= 200 && response.status < 300) {
                if (payload.callback) {
                  dispatch(
                    payload.callback({
                      data: json,
                      payload,
                    })
                  )
                }
                return json
              }
              if (
                response.status >= 400 &&
                response.status < 500 &&
                'error_400' in payload &&
                payload.error_400.length > 0
              ) {
                response_details.type = payload.error_400
                dispatch(errorNotice(response_details))
                dispatch(
                  fetching({
                    fetching: false,
                  })
                )
                dispatch(postSlack(response_details))
                reject(response_details)
              } else if (response.status >= 400 || !json) {
                dispatch(errorNotice(response_details))
                dispatch(
                  fetching({
                    fetching: false,
                  })
                )
                dispatch(postSlack(response_details))
                reject(response_details)
              }
            })
            .then(json => {
              dispatch(
                fetching({
                  fetching: false,
                })
              )
              return json
            })
            .then(json => {
              resolve(json)
            })
            .catch(ex => {
              reject(ex)
            })
        })
        .catch(ex => {
          const response_details = {
            status: `${ex}`,
            text: 'ERRORE DI RETE O TIMEOUT SERVIZI BRUMBRUM',
            url: uri,
            location: window.location.href,
            xray: sha1(Math.random() + new Date().getTime() + uri).substring(
              0,
              7
            ),
            type: 'errore_connessione',
          }
          dispatch(errorNotice(response_details))
          dispatch(
            fetching({
              fetching: false,
            })
          )
          dispatch(postSlack(response_details))
          reject(ex)
        })
    })
  }
export const getTabelleDominioCompass = fetch_getTabelleDominioCompass(
  types.GET_TABELLE_DOMINIO_COMPASS
)
export const getTabelleDominioCompassCallbackOccupazioneAttivita =
  createBasicCreator(
    types.GET_TABELLE_DOMINIO_COMPASS_CALLBACK_OCCUPAZIONEATTIVITA
  )
export const getTabelleDominioCompassCallbackSettoreAttivita =
  createBasicCreator(types.GET_TABELLE_DOMINIO_COMPASS_CALLBACK_SETTOREATTIVITA)
export const getTabelleDominioCompassCallbackCittadinanza = createBasicCreator(
  types.GET_TABELLE_DOMINIO_COMPASS_CALLBACK_CITTADINANZA
)

export const calcolatriciHannoCostiExtra = financements => {
  for (let i = 0; i < financements.length; i++) {
    const finanziamento = financements[i]
    if (finanziamento.costi_extra) {
      return true
    }
  }

  return false
}

export const compassCalcolatriceLogistica =
  callback => (dispatch, getState) => {
    const _financements = getState().financements
    const _preventivo_confermato = !!getState().ordine.preventivo_confermato

    const doCalcolatrice = json => {
      if (
        !totale_ordine_equal_totale_finanziamento(
          _financements.default,
          json.result.totale
        ) ||
        calcolatriciHannoCostiExtra(_financements.default) ||
        _preventivo_confermato
      ) {
        dispatch(
          setCompassCalcolatriceLogistica({ modal_new_rate_logistica: true })
        )
        const { product } = getState()
        let uri = `${window.brumbrum.url_api}/compass/t/v1/calcolatrice/${json.result.id_ordine}/${product.id_auto}`
        let _callback = newDefaultFinancements
        if (isFindomestic(product)) {
          uri = `${window.brumbrum.url_api}/findomestic/t/v1/calcolatrice/${json.result.id_ordine}`
          _callback = newDefaultFinancementsFindomestic
        }
        dispatch(
          getDefaultFinancements({
            method: 'POST',
            uri,
            token: getState().customer.token,
            callback: _callback,
            body: {},
          })
        )
          .then(() => {
            dispatch(
              setCompassCalcolatriceLogistica({
                modal_new_rate_logistica: false,
              })
            )
            /**
             * BRUM-6085 un utente si e' trovato dentro il reroute
             * il percorso di recupero carrello
             * questa funzione viene chiamata in sequenza durante il
             * restore middleware
             */
            //        dispatch(storeDumpItForce())
          })
          .catch(() => null)
      } else {
        dispatch(
          setCompassCalcolatriceLogistica({ modal_new_rate_logistica: false })
        )
      }
    }

    if (getState().ordine.id_ordine && !getState().ordine.totale) {
      dispatch(
        getOrdine({
          callback: getState().newOrdine,
          method: 'GET',
          token: getState().customer.token,
          uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${
            getState().ordine.id_ordine
          }`,
        })
      ).then(doCalcolatrice)
    } else {
      doCalcolatrice({
        result: {
          totale: getState().ordine.totale,
          id_ordine: getState().ordine.id_ordine,
        },
      })
      callback(getState())
    }
  }
